import handHighfive from '@/assets/illustrations/handHighfive.svg';
import { DataPrivacyStatement } from '@/components/DataPrivacyStatement';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card.tsx';
import { useRunOnce } from '@/hooks/use-run-once';
import { useSessionSave } from '@/hooks/use-session-save';
import { setExitMilestone } from '@/hooks/use-session-store/use-session-store';
import { endTrackingSession } from '@/lib/analytics';
import { MILESTONES } from '@/lib/wizard/milestones';

export function InsuranceLinkSent() {
  const { saveSession } = useSessionSave();

  useRunOnce(() => {
    setExitMilestone(MILESTONES.REACH_OUT_PENDING);
    saveSession();
    endTrackingSession();
  });

  return (
    <section>
      <Card className="w-full">
        <CardHeader className="justify-items-center gap-8">
          <img src={handHighfive} alt="" aria-hidden className="size-20" />
          <CardTitle className="text-center sm:text-[32px]">Thanks!</CardTitle>
        </CardHeader>

        <CardContent>
          <p className="mx-auto max-w-[322px] text-center leading-[1.4]">
            We sent you a text and email to finish later when you&apos;re ready to add your
            insurance details.
          </p>
        </CardContent>
      </Card>

      <DataPrivacyStatement />
    </section>
  );
}
